import { Component, OnInit, isDevMode } from '@angular/core';
import { Ng4SpinnerService } from './ng4-spinner.service';
import { Subscription } from 'rxjs/Subscription';
export class Ng4SpinnerComponent implements OnInit {

  subscription: Subscription;
  showSpinner: boolean;
/**
 * @param {?} _ng4SpinnerService
 */
constructor(private _ng4SpinnerService: Ng4SpinnerService) { }
/**
 * @return {?}
 */
ngOnInit() {
    this.showSpinner = false;
    this.subscription = this._ng4SpinnerService.spinnerSubject
      .subscribe((state: boolean) => {
        this.showSpinner = state;
      });
  }
/**
 * @return {?}
 */
ngOnDestroy() {
    if (this.subscription.unsubscribe()) {
      this.subscription.unsubscribe();
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ng4-spinner',
  template: `
    <section *ngIf=showSpinner >
      <article>
        <ng-content></ng-content>
      </article>
    </section>
  `,
  styles: [`

  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Ng4SpinnerService, },
];
}

function Ng4SpinnerComponent_tsickle_Closure_declarations() {
/** @type {?} */
Ng4SpinnerComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Ng4SpinnerComponent.ctorParameters;
/** @type {?} */
Ng4SpinnerComponent.prototype.subscription;
/** @type {?} */
Ng4SpinnerComponent.prototype.showSpinner;
/** @type {?} */
Ng4SpinnerComponent.prototype._ng4SpinnerService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
